import { render } from "./viewReport.vue?vue&type=template&id=73e9cf80&scoped=true"
import script from "./viewReport.vue?vue&type=script&lang=js"
export * from "./viewReport.vue?vue&type=script&lang=js"

import "./viewReport.vue?vue&type=style&index=0&id=73e9cf80&lang=less&scoped=scoped"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73e9cf80"]])

export default __exports__